import { useEffect, useState } from "react";

import toast from "react-hot-toast";
import CancelButton from "../../../components/admin/usable/CancelButton";
import AddButton from "../../../components/admin/usable/AddButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import TableLoader from "../../../components/admin/usable/TableLoader";

import {
  addCoupon,
  couponUpdate,
  deleteCoupon,
  getCouponList,
} from "../../../api/admin/couponApi";

const Coupon = () => {
  const [CouponData, setCouponData] = useState([]);
  const [FormData, setFormData] = useState({
    id: null,
    code: "",
    discount: 0,
    usageLimit: "",
    expirationDate: "",
    createdAt: new Date().toISOString(),
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleEdit = (item) => {
    setFormData({
      id: item.id,
      code: item.code,
      discount: item.discount,
      usageLimit: item.usageLimit,
      expirationDate: item.expirationDate.split("T")[0],
      createdAt: item.createdAt,
    });
  };

  useEffect(() => {
    getCouponList(setCouponData);
  }, []);
  const handleDelete = (item) => {
    const id = item.id;
    deleteCoupon(id, setCouponData);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (FormData.id) {
      couponUpdate(FormData, setFormData, setCouponData);
    } else {
      if (FormData.code !== "") {
        addCoupon(FormData, setFormData, setCouponData);
      } else {
        toast.error("Enter Coupon Code");
      }
    }
  };
  const handleClear = () => {
    setFormData({
      id: null,
      facilityName: "",
      icon: "",
      status: 1,
      createdAt: new Date().toISOString(),
    });
  };
  return (
    <>
      <div className="p-0 lg:p-5 space-y-5">
        <div>
          <p className="font-bold">Coupon</p>
        </div>
        <div className="flex flex-col lg:flex-row gap-5">
          <div className="w-full lg:w-[400px] h-auto border  p-3 bg-white rounded-lg">
            <div>
              <p className="text-sm font-bold pb-3">
                {FormData.id ? "Edit Coupon" : "Add Coupon"}
              </p>
            </div>

            <div className="space-y-6">
              <div>
                <label className="text-xs">Coupon Code</label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                  placeholder="Coupon Code"
                  id="code"
                  value={FormData.code}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label className="text-xs">Discount</label>
                <input
                  type="number"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                  placeholder="Discount(%)"
                  id="discount"
                  value={FormData.discount}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs">Usage Limit</label>
                <input
                  type="number"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                  placeholder="Discount(%)"
                  id="usageLimit"
                  value={FormData.usageLimit}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs">Expiration Date</label>
                <input
                  type="date"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                  id="expirationDate"
                  value={FormData.expirationDate}
                  onChange={handleChange}
                />
              </div>
              <div className="flex justify-end items-center pt-4 gap-x-4">
                <CancelButton onClick={handleClear} size="sm" text="Cancel" />
                <AddButton
                  onClick={handleSubmit}
                  size="sm"
                  text={FormData.id ? "Edit Coupon" : "Add Coupon"}
                />
              </div>
            </div>
          </div>

          <div className="flex-1 w-full min-h-0">
            <div className="  flex-shrink-0  border  p-3 bg-white rounded-lg">
              <div className="p-4 w-full overflow-x-auto">
                <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        ID
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Coupe Code
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Usage Limiation
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Expiration Date
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        CreatedAt
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-200">
                    {CouponData.length > 0 ? (
                      <>
                        {CouponData.map((item, index) => {
                          return (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {index + 1}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item.code}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item.usageLimit}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {item.expirationDate.split("T")[0]}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {item.createdAt.split("T")[0]}
                              </td>
                              <td className="px-4 py-3 text-sm flex gap-2">
                                <EditButton
                                  onClick={() => handleEdit(item)}
                                  text="Edit"
                                />
                                <DeleteButton
                                  onClick={() => handleDelete(item)}
                                  text="Delete"
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <TableLoader colSpan={6} />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coupon;
